<template>
  <ul class="breadcrumb" :class="{ 'bg-transparent': transparent }">
    <slot></slot>
  </ul>
</template>
<script>
export default {
  name: 'breadcrumb',
  props: {
    transparent: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style>
.breadcrumb {
  list-style: none;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 8px 16px 0 16px; /* small top gutter like the screenshot */
  font-size: 14px;
}
.bg-transparent {
  background: transparent;
}
</style>
